

























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class BaseButton extends Vue {
  @Prop({ default: 'primary' }) color!: string
  @Prop({ default: false }) outline!: boolean
  @Prop({ default: '' }) buttonClass!: string
  @Prop() noHover!: boolean
  @Prop({ default: 'md' }) size!: 'xs' | 'sm' | 'md' | 'lg' | 'xl'

  get colorize() {
    if (this.$attrs.disable)
      return 'tes-grey-dark'
    else
      return this.color
  }

  get btnClass() {
    return this.noHover ? 'no-hover' : ''
  }

  get setSize() {
    if (this.size === 'xs') {
      return 'line-height: 0.7em'
    } else if (this.size === 'sm') {
      return 'line-height: 1em'
    } else if (this.size === 'md') {
      return 'line-height: 1.7em'
    } else if (this.size === 'lg') {
      return 'line-height: 3em'
    } else if (this.size === 'xl') {
      return 'line-height: 3.7em'
    }
  }
}
